var QUEO = window.QUEO || {};

QUEO.mHeader = (function ($) {

    function init() {

        // Note: since it is using live-binds (handler is bound to document) it is not necessary to re-initialize when new content is inserted

        // bind accordion trigger/transition handler
        $(document).on('click', '.js-accordion-trigger:not(.is-animating)', triggerHandler).on('transitionend', '.js-accordion-content', transitionHandler);

        function triggerHandler(e) {

            // don't toggle accordion if target is tooltip
            if($(e.target).hasClass('js-tooltip')) {
                return;
            }

            var $trigger = $(this),
                $item = $trigger.closest('.js-accordion-item').toggleClass('is-open'),
                $content = $item.find('.js-accordion-content'),
                isOpen = $item.hasClass('is-open');

            // toggle accessibility switch if present
            if($item.attr('aria-expanded')) {
                $item.attr('aria-expanded', isOpen);
            }

            // postpone animation if item has initially 'is-open' set and therefore no style.height was set via JS
            if(!isOpen && $content.get(0).style.height === '') {

                $content.css({
                    height: $content.children().outerHeight(),
                    visibility: 'visible'
                });
                setTimeout(animate, 40);

            } else {

                animate();

            }

            function animate() {

                $trigger.addClass('is-animating');

                // "toggle" height for css transition
                if(isOpen) {

                    $content.css('height', 0);
                    $content.css('height', $content.children().outerHeight());

                } else {

                    $content.css('height', $content.children().outerHeight());
                    $content.css('height', 0);

                }

            }

        }
        function transitionHandler(e) {

            var onCollapseEnd = e.target === this,
                onFadeEnd = e.target === $(this).children().get(0);

            // ignore delegated transitionend events from children (caused by hover states, styled dropdowns etc.)
            if(!(onFadeEnd || onCollapseEnd)) {
                return;
            }

            var $content = $(this),
                $item = $content.closest('.js-accordion-item'),
                $trigger = $item.find('.js-accordion-trigger');

            // remove style and let handle css current state
            $content.css({
                height: '',
                visibility: ''
            });

            $trigger.removeClass('is-animating');

        }

    }

    $(init);
})(jQuery);
